/*
    © 2022 EcomGradautes.com
    https://www.ecomgraduates.com
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async () => {
    const offcanvasCart = document.querySelector('#offcanvas-cart')
    const cartBadges = document.querySelectorAll('.cart-badge')
    const cartSummary = document.querySelector('#template-cart-summary')

    offcanvasCart?.classList.add('loading')

    const respoonse = await fetch(window.location.href)
    const data = await respoonse.text()
    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    offcanvasCart?.querySelector('.offcanvas-body')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
    offcanvasCart?.querySelector('.offcanvas-footer')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))
    cartSummary?.querySelector('.card-body')
        .replaceWith(newDocument.querySelector('#template-cart-summary .card-body'))

    cartBadges.forEach((badge) => {
        badge.style.display = 'block'
        badge.textContent = newDocument.querySelector('.cart-badge').textContent
    })

    offcanvasCart.classList.remove('offcanvas-cart-empty')

    offcanvasCart?.classList.remove('loading')
    initCartGoal()
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value
        })
    })
    window.refreshCartContents()
}

// Remove buttons
window.onRemoveLineItem = async (btn) => {
    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0
        })
    })
    window.refreshCartContents()
}

// Cart note - Show button on keydown
window.showNoteButton = (input) => {
    input.closest('.cart-note-wrapper').querySelector('button').style.display = 'block'
}

// Cart note - Save note via ajax
window.saveCartNote = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const note = btn.closest('.cart-note-wrapper').querySelector('[name="note"]').value

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
    })

    btn.innerHTML = '✓'

    setTimeout(() => {
        btn.innerHTML = btn.dataset.text
    }, 2000)
}

// Checkout button - indicate loading on click
window.onCheckoutBtnClick = (btn) => {
    btn.style.height = btn.clientHeight + 'px'
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
}

// Summary card  - make it sticky on desktop
const summaryCard = document.querySelector('#template-cart-summary')
if (summaryCard) {
    if (window.matchMedia('min-width: 992px')) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight || 0
        summaryCard.style.position = 'sticky'
        summaryCard.style.top = `${navbarHeight + 20}px`
    }
}

// Offcanvas cart - open it with direct url (hash based)
if (window.location.hash.includes('#cart') && document.querySelector('#offcanvas-cart')) {
    bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
}

// Handle Plus/Minus in quantity steppers
window.onQtyPlusMinus = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    if (btn.classList.contains('btn-plus')) {
        input.value = inputValue + 1
    } else {
        if (Number(input.value) === 1 && btn.closest('.shopify-product-form')) {
            return
        }
        if (Number(input.value) === Number(input.dataset.minQty))  {
            return
        }
        input.value = inputValue - 1
    }

    const event = new Event('change')
    input.dispatchEvent(event)
}

// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-goal .progress-bar')

    if (!progressBar) return

    setTimeout(() => {
        progressBar.style.width = progressBar.dataset.width
    }, 250)

    setInterval(() => {
        if (sessionStorage.getItem('scDiscountData') === null) {
            document.querySelector('#cart-goal').removeAttribute('hidden')
        } else {
            const value = JSON.parse(sessionStorage.getItem('scDiscountData'))
            if (value.code) {
                document.querySelector('#cart-goal').setAttribute('hidden', 'hidden')
            } else {
                document.querySelector('#cart-goal').removeAttribute('hidden')
            }
        }
    }, 2000)
}
initCartGoal()

// Upgrade to subscription button form (button)
window.upgradeToSubscription = async (btn) => {
    btn.textContent = 'Upgrading...'

    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: Number(btn.dataset.variantId),
                selling_plan: Number(btn.dataset.sellingPlanId),
                quantity: 1
            }]
        })
    })

    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0
        })
    })

    window.refreshCartContents()
}

// Change line item subscription (select)
window.changeLineItemSubscription = async (select) => {
    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: Number(select.dataset.variantId),
                selling_plan: Number(select.value),
                quantity: 1
            }]
        })
    })

    await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: select.dataset.lineItemKey,
            quantity: 0
        })
    })

    window.refreshCartContents()
}






